import { z } from "zod";
import { optionalFilterString } from "@/schemas/filter.schema";

export const userFilterSchema = z.object({
	search: optionalFilterString,
	enabled: optionalFilterString,
});
